import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mb-radio-field',
  templateUrl: './mb-radio-field.component.html',
  styleUrls: ['./mb-radio-field.component.scss']
})
export class MbRadioFieldComponent implements OnInit {

  @Input() title;
  @Input() wrap: boolean;
  @Input() misfit: boolean;
  @Input() fullWidth: boolean;
  @Input() labelPosition: string;

  constructor() { }

  ngOnInit() {
  }

}
